import { render, staticRenderFns } from "./LabRequest.vue?vue&type=template&id=48d70660&"
import script from "./LabRequest.vue?vue&type=script&lang=js&"
export * from "./LabRequest.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports